import { useCallback, useContext } from 'react';

import { AuthContext } from '../contexts/auth';
import MixPanelHelper, { shouldAllowLinksTracking } from '../helpers/mixpanel';
import { isInternalAccess } from '../utils/internal-access';

const useMixPanel = () => {
  const { userInfo } = useContext(AuthContext);
  const mixPanelInstance = MixPanelHelper(userInfo)?.getInstance();
  const track = useCallback(
    (eventName, eventProps) => {
      if (!isInternalAccess(userInfo.isAdmin)) {
        mixPanelInstance?.track(eventName, eventProps);
        return true;
      }
      return null;
    },
    [userInfo.isAdmin, mixPanelInstance]
  );

  const trackLink = useCallback(
    (domElementId, eventName) => {
      if (shouldAllowLinksTracking(userInfo.isAdmin, domElementId)) {
        mixPanelInstance?.track_links(domElementId, eventName);
      }
    },
    [userInfo.isAdmin, mixPanelInstance]
  );

  return {
    track,
    trackLink,
  };
};

export default useMixPanel;
